import React from "react";
import { I18n } from "../../../../models/I18n";
import ReportSummarySection from "../ReportSummarySection/ReportSummarySection";
import ResultColorBar from "../ResultColorBar/ResultColorBar";
import { ReportSummaryColors } from "../../constants/ReportSummaryColors";
import { RiskIndicator } from "../../constants/RiskIndicator";

export interface IntellectualCapabilitySummaryProps {
    title: string;
    basedOn: string;
    handle: string;
    evaluation: string;
    scrollToSection?: (elementId: string) => void;
    score: number;
    cutOff: number|null;
    outcome: RiskIndicator;
    i18n: I18n;
    classes?: { titleDecoration: string; }
}

const IntellectualCapabilitySummary = ({
    title,
    basedOn,
    handle,
    evaluation,
    scrollToSection,
    score,
    cutOff,
    outcome,
    i18n,
    classes,
}: IntellectualCapabilitySummaryProps) => {
    const getCutoffEvaluation = () => {
        if (!score || !cutOff) {
            return "";
        }
        return score < cutOff
            ? i18n.report_management_summary_intellectual_capability_not_passed
            : i18n.report_management_summary_intellectual_capability_passed;
    };

    const getResultColor = () => {
        if (cutOff) {
            return score < cutOff ? ReportSummaryColors.ORANGE : ReportSummaryColors.GREEN;
        }

        if (!outcome) {
            return null;
        }

        return outcome === RiskIndicator.RISKY ? ReportSummaryColors.ORANGE : ReportSummaryColors.GREEN;
    };

    return (
        <ReportSummarySection
            basedOn={basedOn}
            handle={handle}
            i18n={i18n}
            scrollToSection={scrollToSection ? scrollToSection : null}
            showViewAll={!!scrollToSection}
            title={title}
            classes={ classes || { titleDecoration: "" }}
        >
            <ResultColorBar color={getResultColor()} htmlText={getCutoffEvaluation() || evaluation} />
        </ReportSummarySection>
    );
};

export default IntellectualCapabilitySummary;
